module.exports = __webpack_public_path__ + "static/media/righthn.ae7537db.png";